export const criteriaMapping: { [key: string]: string } = {
  // FM8
  bestLapTime: "challengeCriteria.fm.bestLapTime",
  distanceTravel: "challengeCriteria.fm.distanceTravel",
  racePosition: "challengeCriteria.fm.racePosition",

  // CS2
  kills: "challengeCriteria.cs.kills",
  assists: "challengeCriteria.cs.assists",
  deaths: "challengeCriteria.cs.deaths",
  overall_kd: "challengeCriteria.cs.overall_kd",
  averageKillStreak: "challengeCriteria.cs.averageKillStreak",
  highestKillStreak: "challengeCriteria.cs.highestKillStreak",
  totalKillHs: "challengeCriteria.cs.totalKillHs",
  averageAmmoRequiredToKill: "challengeCriteria.cs.averageAmmoRequiredToKill",
  mvps: "challengeCriteria.cs.mvps",
  score: "challengeCriteria.cs.score",
  time: "challengeCriteria.cs.time",

  // Fall Guys
  fame: "challengeCriteria.fallguys.criteria.fame",
  bronze: "challengeCriteria.fallguys.criteria.bronze",
  silver: "challengeCriteria.fallguys.criteria.silver",
  gold: "challengeCriteria.fallguys.criteria.gold",
  total_badge_points: "challengeCriteria.fallguys.criteria.total_badge_points",
  positionPoints: "challengeCriteria.fallguys.criteria.positionPoints",
  finalPoints: "challengeCriteria.fallguys.criteria.finalPoints",
};
